// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {DigitalUserAccountItem} from './digital-user-account-item';
import {ProfileDigitalUserSearchResult} from './profile-digital-user-search-result';

export const DigitalUserAccountDetails = t.struct({
    digitalUserAccountList: t.list(DigitalUserAccountItem),
    digitalUserSearchResults: t.list(ProfileDigitalUserSearchResult),
    isDigitalUserAccountLoading: t.Boolean,
    errorMessage: t.String
}, {
    defaultProps: {
        digitalUserAccountList: [],
        digitalUserSearchResults: [],
        isDigitalUserAccountLoading: true,
        errorMessage: ''
    },
    name: 'DigitalUserAccountDetails',
    strict: true
});
